import React from "react";

const FromConnections = () => {
    return (
        <div>
            <p>Upload from Connections (API or database connections)</p>
        </div>
    );
};

export default FromConnections;
